var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-ajax-table-with-crud-actions',{attrs:{"id":_vm.id,"titles":_vm.titles,"props":_vm.props,"bus":_vm.bus,"endpoint":_vm.endpoint,"edit-url":_vm.edit_url}})
}
var staticRenderFns = []

export { render, staticRenderFns }